export default __webpack_public_path__ + "static/media/amaggi.3e7acc1b.svg";